export enum ScoreType {
  NUMERICAL = 'numerical',
  CONCEPTUAL = 'concept',
}
